<!-- 转码模版 -->
<template>
  <div class="Transcode">
    <cs-table :tableCols="tableCols" :tableData="tableData" :paginationOption="pageOption"
      @size-change="sizeChangeHandler"
      @current-change="currentPageHandler">
      <template slot-scope="scope" slot="Codec"> {{scope.row.VideoTemplate.Codec}} </template>
      <template slot-scope="scope" slot="Bitrate"> {{scope.row.VideoTemplate.Bitrate}} </template>
      <template slot-scope="scope" slot="ResolutionAdaptive">
        <span v-if="scope.row.VideoTemplate.Width==0&&scope.row.VideoTemplate.Height==0">源视频相同</span>
        <p v-else>{{scope.row.VideoTemplate.Width>0?scope.row.VideoTemplate.Width:'按比例缩放'}}*
          {{scope.row.VideoTemplate.Height>0?scope.row.VideoTemplate.Height:'按比例缩放'}}
        </p>
      </template>
      <template slot-scope="scope" slot="Fps"> {{scope.row.VideoTemplate.Fps}} </template>
      <template slot-scope="scope" slot="Codec"> {{scope.row.AudioTemplate.Codec}} </template>
      <template slot-scope="scope" slot="SampleRate"> {{scope.row.AudioTemplate.SampleRate}} </template>
      <template slot-scope="scope" slot="Bitrate"> {{scope.row.AudioTemplate.Bitrate}} </template>
      <template slot-scope="scope" slot="AudioChannel">
        <span v-if="scope.row.AudioTemplate.AudioChannel==1">单通道</span>
        <span v-if="scope.row.AudioTemplate.AudioChannel==2">双通道</span>
        <span v-if="scope.row.AudioTemplate.AudioChannel==6">立体声</span>
      </template>
    </cs-table>
  </div>
</template>
<script>
import { fetchTencentTemplate } from '@/resource/api/index'
export default {
  name: 'Transcode',
  data () {
    return {
      tableData: [], // 转码模版TABLE DATA
      pageOption: {},
      tableCols: [ // 节目发布表头
        { prop: 'Name', label: '模板名称' },
        { prop: 'Container', label: '封装格式' },
        { prop: 'Codec', label: '视频编码', type: 'slot' },
        { prop: 'Bitrate', label: '码率kbps', type: 'slot' },
        { prop: 'ResolutionAdaptive', label: '分辨率px', type: 'slot' },
        { prop: 'Fps', label: '帧率fps', type: 'slot' },
        { prop: 'Codec', label: '音频编码', type: 'slot' },
        { prop: 'SampleRate', label: '音频采样率', type: 'slot' },
        { prop: 'Bitrate', label: '音频码率kbps', type: 'slot' },
        { prop: 'AudioChannel', label: '音频声道', type: 'slot' }
      ],
      searchParams: {
        limit: this.$store.state.pageLimit,
        offset: 1
      }
    }
  },
  created () {
    this.pageOption['page-size'] = this.$store.state.pageLimit
    this.fetchTranscode()
  },
  methods: {
    // 转码模版 DATA
    fetchTranscode () {
      fetchTencentTemplate(this.searchParams).then((res) => {
        if (res.code == '1') {
          this.tableData = res.results
          this.pageOption = {
            ...this.pageOption,
            'current-page': this.searchParams.offset,
            total: parseInt(res.total)
          }
        }
      })
    },
    sizeChangeHandler (val) {
      this.searchParams.limit = val
      this.searchParams.offset = 1
      this.fetchTranscode()
    },
    currentPageHandler (val) {
      this.searchParams.offset = val
      this.fetchTranscode()
    }
  }
}
</script>
